<template>
  <div class="animated fadeIn">
    <b-card no-body>
      <b-card-header>
        <i class="icon-note"></i> Edit Quotes
        <div class="card-header-actions">
          <a class="card-header-action" href="quotes" rel="noreferrer noopener">
            <small class="text-muted">Back</small>
          </a>
        </div>
      </b-card-header>
      <b-card-body>
        <div class="loading" v-if="isLoading == true">
            <div class="sk-three-bounce">
                <div class="sk-child sk-bounce1"></div>
                <div class="sk-child sk-bounce2"></div>
                <div class="sk-child sk-bounce3"></div>
            </div>
        </div>
        <b-row>
          <b-col sm="12">
            <!--<h6>Simple Form</h6>-->
            <b-form v-on:submit.prevent="onSubmit" novalidate>
              <b-form-group id="titleInputGroup1"
                            label="Title"
                            label-for="title">
                <b-form-input id="title"
                              type="text"
                              v-model.lazy.trim="$v.form.title.$model"
                              :state="chkState('title')"
                              aria-describedby="titleFeedback"
                              placeholder="Please Enter Notification Title"
                              autocomplete='given-name'
                              autofocus />
                <b-form-invalid-feedback id="titleFeedback">
                  <span v-if="!$v.form.title.maxLength">- Jumlah karakter judul tidak boleh lebih dari 100 karakter!</span>
                  <span v-if="!$v.form.title.required">- Judul tidak boleh kosong!</span>
                </b-form-invalid-feedback>
              </b-form-group>
              <b-form-group id="quotesGroup"
                            label="Quotes"
                            label-for="quotes">
                <b-form-textarea
                  id="textarea-rows"
                  v-model.lazy.trim="$v.form.quotes.$model"
                  :state="chkState('quotes')"
                  placeholder="Enter quotes notification ..."
                  aria-describedby="quotes"
                  rows="8"
                ></b-form-textarea>
                <b-form-invalid-feedback id="quotes">
                  <span v-if="!$v.form.quotes.maxLength">- Jumlah karakter quotes tidak boleh lebih dari 160 karakter!</span>
                  <span v-if="!$v.form.quotes.required">- Quotes tidak boleh kosong! </span>
                </b-form-invalid-feedback>
              </b-form-group>
              <b-form-group id="authorGroup"
                            label="Author"
                            label-for="author">
                <b-form-input id="author"
                              type="text"
                              v-model.lazy.trim="$v.form.author.$model"
                              :state="chkState('author')"
                              aria-describedby="authorFeedback"
                              placeholder="Please Enter Auhtor"
                              autocomplete='given-name'
                              autofocus />
                <b-form-invalid-feedback id="authorFeedback">
                  <span v-if="!$v.form.author.required">- Author tidak boleh kosong!</span>
                </b-form-invalid-feedback>
              </b-form-group>
              <b-button type="submit" variant="primary">
                Submit
              </b-button>
            </b-form>
            <br/>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate"
import { required, maxLength } from "vuelidate/lib/validators"


export default {
  name: "push-notification",
  data() {
    return {
      form: {
        title: '',
        quotes: '',
        author: ''
      },
      filterText: '',
      seleceted: '',
      // selectedUsers: this.$refs.vuetable.selectedTo,
      errors: {
        message: [],
        status: [],
        code: '',
        headers: [],
        form: {
          title: [],
          quotes: [],
          author: []
        },
      },
      isLoading: false
    }
  },
  computed: {
    formStr() { return JSON.stringify(this.form, null, 4) },
    isValid() { return !this.$v.form.$anyError },
    isDirty() { return this.$v.form.$anyDirty },
    invCheck() { return 'You must accept before submitting' },
  },
  mixins: [validationMixin],
  validations: {
    form: {
      title: {
        required,
        maxLength: maxLength(100)
      },
      quotes: {
        required,
        maxLength: maxLength(160)
      },
      author: {
        required
      }
    }
  },
  created() {
    this.$http.get(`saver/content/` + this.$route.params.id)
    .then((result) => {
      this.form.title = result.data.data.title;
      this.form.quotes = result.data.data.quotes;
      this.form.author = result.data.data.author;
    }).catch((error) => {
      if (error.response) {
        this.errors.code = error.response.data.meta.code;
        this.errors.status = error.response.status;
        this.errors.headers = error.response.headers;
      }
    })
  },
  methods: {
    onSubmit() {
      this.validate()
      this.isLoading = true
      this.$http.put(`saver/content/` + this.$route.params.id, {
        title: this.form.title,
        quotes: this.form.quotes,
        author: this.form.author,
        _method: 'POST'
      }).then((result) => {
        this.$router.push("/quotes");
        this.$toasted.success(result.data.meta.message)
      }).catch((error) => {
        if (error.response) {
          this.isLoading = false
          this.errors.code = error.response.status;
          this.errors.status = error.response.data.meta.code;
          this.errors.headers = error.response.headers;
          if(this.errors.status == 422) {
            this.errors.message = error.response.data.meta.message;
            this.errors.form.title = this.errors.message.title;
            this.errors.form.quotes = this.errors.message.quotes;
            this.errors.form.author = this.errors.message.author;
          }
        }
      })
    },
    chkState(val) {
      const field = this.$v.form[val]
      return !field.$dirty || !field.$invalid
    },
    findFirstError(component = this) {
      if (component.state === false) {
        if (component.$refs.input) {
          component.$refs.input.focus()
          return true
        }
        if (component.$refs.check) {
          component.$refs.check.focus()
          return true
        }
      }
      let focused = false
      component.$children.some((child) => {
        focused = this.findFirstError(child)
        return focused
      })

      return focused
    },
    validate() {
      this.$v.$touch()
      this.$nextTick(() => this.findFirstError())
      return this.isValid
    },
  }
}
</script>

<style scoped>
.btn.disabled {
  cursor: auto;
}

.invalid-feedback {
    font-size: 100% !important;
}
#contentFeedback {
  color: #f86c6b !important;
  font-size: 100%;
}
</style>
<style>
/* Absolute Center Spinner */
.loading {
  position: fixed;
  z-index: 999;
  height: 2em;
  width: 2em;
  overflow: visible;
  margin: auto;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}

/* Transparent Overlay */
.loading:before {
  content: '';
  display: block;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.3);
}

</style>
<style src="spinkit/scss/spinkit.scss" lang="scss" />
